import { Button } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import useOrdersContext from 'contexts/orders.context';

type AppreciationModalProps = {
  show: boolean;
  onClose: () => void;
};

const AppreciationModal: FC<AppreciationModalProps> = ({ show, onClose }) => {
  const [note, setNote] = useState('');
  const { createOrderForm, setCreateOrderForm } = useOrdersContext();

  const handleClose = () => {
    onClose();
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='Appreciate your team'
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <div>
          <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
            <p className='text-[#2E3031]'>Add note</p>
          </div>
          <LocalTextArea
            placeholder='Tell your team they are doing a great job'
            className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[135px]'
            value={note}
            onChange={(e) => setNote(e.target.value)}
            autoFocus
          />
        </div>
        <div className='mt-5 flex justify-end'>
          <Button
            color='primary'
            variant='block'
            className='w-[139px] h-[41px]'
            onClick={() => {
              setCreateOrderForm({
                ...createOrderForm,
                order_details: {
                  ...createOrderForm.order_details,
                  appreciation_note: note
                }
              });
              onClose();
            }}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default AppreciationModal;
